import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type SendIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const SendIllustration = ({ ...props }: SendIllustrationProps) => (
  <BaseIllustration width="64" height="64" viewBox="0 0 64 64" {...props}>
    <g strokeWidth={2} strokeLinecap="square" fill="none">
      <polyline points="60 5 17 36.244 17 58 27 51" strokeLinecap="butt" />
      <polygon points="4 27 60 5 49 59 4 27" />
    </g>
  </BaseIllustration>
);

SendIllustration.displayName = 'SendIllustration';
